export class StringUtil {
	static #FRACTION_MAP = new Map([
		['25', '¼'],
		['5', '½'],
		['75', '¾'],
		['33', '⅓'],
		['333', '⅓'],
		['66', '⅔'],
		['666', '⅔'],
		['125', '⅛'],
		['375', '⅜'],
		['875', '⅞'],
	]);

	static ToFraction(seed) {
		const [base, decimals] = seed.toString().split(".");
		const fraction = this.#FRACTION_MAP.get(decimals?.substring(0, 3));
		return fraction ? `${base === "0" ? "" : base}${fraction}` : seed;
	}

	/**
	 * @param {String|Number} seed
	 */
	static ToPhoneNumberFormat(seed) {
		if (!seed) {
			return "";
		}

		const numberValue = seed.toString().replace(/^\D/g, "");
		if (numberValue.length > 10) {
			return seed;
		}

		return numberValue.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
	}
	
	static Pluralize(count, word, suffix = undefined) {
		return count === 1 ? word : `${word}${suffix ?? "s"}`;
	}
}